module.exports = __webpack_public_path__ + "static/media/all-led-lightning.d4bfbf10.jpg";